const IGNORE_ERRORS = [
    /onVisibilityChange\((intel|intel-student)\/static\/OT\/src\/js\/ot\/subscriber\/index\)/,
];
export default IGNORE_ERRORS;
//# sourceMappingURL=ignoreErrors.js.map